// Statistics.jsx
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchStatisticsData } from "../../features/Statistics/Statistics";
import Card from "./Card";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import SwiperCore from "swiper/core";
import { motion } from "framer-motion";
import { SeeMore } from "../../Buttons/Buttons";
import Loading from "../Loading";

// Initialize Swiper modules
SwiperCore.use([Navigation, Pagination, Autoplay]);

function Statistics({ onVisible }) {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  const { statistics,loading } = useSelector((state) => state.statistics);

  useEffect(() => {
    // You can keep this initial fetch if you want; it will run on mount.
    dispatch(fetchStatisticsData(200));
  }, [dispatch, i18n.language]);
  if(loading) return <Loading />
  return (
    <motion.section
      className="relative py-16 "
      initial={{ opacity: 0, y: 10 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-100px 0px -100px 0px" }}
      onViewportEnter={() => {
        // notify parent to load all pages when statistics is visible
        if (typeof onVisible === "function") onVisible();
      }}
    >
      <div className="container mx-auto px-4">
        {/* Header Section */}
        <div className="mb-12 text-center">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl font-bold text-gray-900 mb-4"
          >
            {t("zadStatistics")}
          </motion.h2>
          <div className="flex items-center justify-center gap-2 text-gray-600">
            <span>{t("latestUpdate")}:</span>
            <span className="font-medium text-emerald-600">
              {statistics[0]?.last_update?.split("T")[0]}
            </span>
          </div>
        </div>

        {/* Swiper Container */}
        <div className="relative group md:px-8">
          {/* Gradient Overlays */}
          <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white/10 to-transparent z-20" />
          <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white/10 to-transparent z-20" />

          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={10}
            slidesPerView={1}
            breakpoints={{
              640: { slidesPerView: 2 },
              1024: { slidesPerView: 4 },
              1280: { slidesPerView: 5 },
            }}
            key={"lang_" + i18n.language}
            pagination={{ clickable: true }}
            autoplay={{ delay: 5000 }}
            loop={true}
            className="py-12"
          >
            {statistics?.map((statistic) => (
              <SwiperSlide key={statistic.id}>
                <div className="h-full flex justify-center p-4">
                  <Card statistic={statistic} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="flex justify-center mx-auto mt-3">
          <SeeMore link={"/show/statistics"} />
        </div>
      </div>
    </motion.section>
  );
}

export default Statistics;
